import { render, staticRenderFns } from "./uac.vue?vue&type=template&id=0fc03ea6&scoped=true"
import script from "./uac.vue?vue&type=script&lang=js"
export * from "./uac.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc03ea6",
  null
  
)

export default component.exports